import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DefaultTemplate } from './components/default.template';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UbudUtilitiesModule } from '@ubud/utilities';
import { UbudTemplateModule } from '@ubud/template';
import { UbudTooltipModule } from '@ubud/tooltip';
import { HeaderContainer } from './containers/header.container';
import { FrontPage } from './pages/front.page';
import { DefaultPage } from './pages/default.page';
import { FilterContainer } from './containers/filter.container';
import { UbudUserControlModule } from '@ubud/user-control';
import { UbudDropdownModule } from '@ubud/dropdown';
import { FooterComponent } from './components/footer.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LemsarInstitutionDomainModule } from '@lemsar/institution/domains/module';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { GridModule } from '@progress/kendo-angular-grid';
import { LemsarCommonDomainModule } from '@lemsar/common/domains/module';
import { SharedCommonModule } from '@shared/module/common/common.module';
import { ServicePickerModule } from '@naker/service-picker';
import { UserControlModule } from '@naker/user-control';
import { LemsarMessageDomainModule } from '@lemsar/message/domains/module';
import { SidebarModule } from '@shared/module/sidebar/sidebar.module';
import { LemsarUserDomainModule } from '@lemsar/user/domains/module';

const COMPONENTS: any[] = [DefaultTemplate, FooterComponent];
const CONTAINERS: any[] = [HeaderContainer, FilterContainer];
const PAGES: any[] = [FrontPage, DefaultPage];
const KENDO_MODULES: any[] = [DialogModule, GridModule];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        ButtonsModule,
        DropDownsModule,
        UbudUtilitiesModule,
        UbudTemplateModule,
        UbudTooltipModule,
        UbudDropdownModule,
        UbudUserControlModule,
        LemsarInstitutionDomainModule,
        LemsarCommonDomainModule,
        SharedCommonModule,
        ServicePickerModule,
        UserControlModule,
        LemsarMessageDomainModule,
        LemsarUserDomainModule,
        ...KENDO_MODULES,
        SidebarModule,
    ],
    declarations: [...CONTAINERS, ...PAGES, ...COMPONENTS],
    exports: [...CONTAINERS, ...PAGES, ...COMPONENTS],
})
export class LemsarDefaultTemplateModule {}



// WEBPACK FOOTER //
// ./apps/frontend/src/template/default/default-template.module.ts